import { render, staticRenderFns } from "./libraryItemDialog.vue?vue&type=template&id=0b16d6b5&"
import script from "./libraryItemDialog.vue?vue&type=script&lang=js&"
export * from "./libraryItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports